/**
 * @module lib/appserver/entityHeaders/common
 * Common interface for all entities in the app.
 */

import { aggregateSchoolID, aggregateEntityID } from "lib/appserver/aggregate";

export const defaultProperties = {
  appserverReferenceType: undefined,
  appserverReferenceEntityID: undefined,
  serverID: undefined,
  serverHostname: undefined,
  remoteSchoolID: undefined,
  schoolID: undefined,
  remoteID: undefined,
  id: undefined
}

export function appserverAdapter(rawEntity) {
  const props = {
    appserverReferenceType: rawEntity.appserver_reference_type,
    appserverReferenceEntityID: rawEntity.appserver_remote_entity_id,
    serverID: rawEntity.appserver_server_id,
    serverHostname: rawEntity.appserver_server_hostname,
    remoteSchoolID: rawEntity.appserver_remote_school_id,
    remoteID: rawEntity.id
  }
  props.schoolID = aggregateSchoolID(props);
  props.id = aggregateEntityID(props);
  return props;
}



// WEBPACK FOOTER //
// ./src/lib/appserver/entityHeaders/common.js